"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumberFieldDisplayValueWithLabels = exports.getNumberFieldDisplayValue = exports.getValueWithLabels = exports.DetailedDecimalFormatter = exports.addLabels = exports.convertNumberToFormatedString = void 0;
const number_1 = require("../utils/number");
const bignumber_js_1 = require("bignumber.js");
const abbreviationToDivider = {
    K: 1000,
    M: 1000000,
    B: 1000000000,
};
const convertNumberToFormatedString = ({ value, precision, decimalSeparator, thousandSeparator, numberAbbreviation = null, }) => {
    var _a;
    if (isNaN(Number(value))) {
        return String(value);
    }
    // -0 - wrong value, must not format the value
    if (value === "-0") {
        return value;
    }
    if (value === undefined || value === null || value === "") {
        return "";
    }
    if (typeof value === "string") {
        value = value.replace(",", ".");
    }
    const formattedValue = new bignumber_js_1.BigNumber(value)
        .dividedBy((_a = abbreviationToDivider[numberAbbreviation !== null && numberAbbreviation !== void 0 ? numberAbbreviation : ""]) !== null && _a !== void 0 ? _a : 1)
        .toFormat(precision, {
        decimalSeparator,
        groupSeparator: thousandSeparator,
        groupSize: 3,
    });
    return `${formattedValue}${numberAbbreviation !== null && numberAbbreviation !== void 0 ? numberAbbreviation : ""}`;
};
exports.convertNumberToFormatedString = convertNumberToFormatedString;
const addLabels = (value, prefix, suffix) => (value ? `${prefix.trim()} ${value} ${suffix.trim()}`.trim() : "");
exports.addLabels = addLabels;
/**
 * @deprecated: Use convertNumberToFormatedString helper instead of
 */
class DetailedDecimalFormatter {
    transform(value, locale, options = {
        precision: 0,
        separator: false,
    }) {
        if (!locale || isNaN(Number(value))) {
            return String(value);
        }
        if (value === undefined || value === null || value === "") {
            return null;
        }
        return (0, exports.convertNumberToFormatedString)({
            value,
            precision: options.precision,
            decimalSeparator: (0, number_1.getDecimalSeparator)(locale),
            thousandSeparator: options.separator ? (0, number_1.getGroupSeparator)(locale) : "",
        });
    }
}
exports.DetailedDecimalFormatter = DetailedDecimalFormatter;
/**
 * @deprecated: Use addLabels helper instead of
 */
const getValueWithLabels = (field, value) => {
    var _a, _b;
    if (!(value && field.params.include_labels)) {
        return value !== null && value !== void 0 ? value : "";
    }
    return (0, exports.addLabels)(value, (_a = field.params.prefix) !== null && _a !== void 0 ? _a : "", (_b = field.params.suffix) !== null && _b !== void 0 ? _b : "");
};
exports.getValueWithLabels = getValueWithLabels;
/**
 * @deprecated: Use convertNumberToFormatedString helper instead of
 */
const getNumberFieldDisplayValue = (value, precision, separator, locale) => {
    var _a;
    return (_a = new DetailedDecimalFormatter().transform(value, locale, {
        precision,
        separator,
    })) !== null && _a !== void 0 ? _a : "";
};
exports.getNumberFieldDisplayValue = getNumberFieldDisplayValue;
/**
 * @deprecated: Use convertNumberToFormatedString and addLabels helpers instead of
 */
const getNumberFieldDisplayValueWithLabels = (value, field, locale) => {
    var _a, _b;
    return (0, exports.getValueWithLabels)(field, (0, exports.getNumberFieldDisplayValue)(value, (_a = field.params.precision) !== null && _a !== void 0 ? _a : 0, (_b = field.params.separator) !== null && _b !== void 0 ? _b : false, locale));
};
exports.getNumberFieldDisplayValueWithLabels = getNumberFieldDisplayValueWithLabels;
